// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: packages/shared/src/protocol/actions/*.ts
import * as m0 from './actions/core';
import * as m1 from './actions/decor';
import * as m2 from './actions/digging';
import * as m3 from './actions/fishing';
import * as m4 from './actions/house';
import * as m5 from './actions/items';
import * as m6 from './actions/mail';
import * as m7 from './actions/museum';
import * as m8 from './actions/nature';
import * as m9 from './actions/news';
import * as m10 from './actions/shop';
import * as m11 from './actions/tutorial';
import * as m12 from './actions/villagers';
export const actionModules = [m0, m1, m2, m3, m4, m5, m6, m7, m8, m9, m10, m11, m12] as const;
